import { render, staticRenderFns } from "./Leftmenu_wedding.vue?vue&type=template&id=12418283&scoped=true"
import script from "./Leftmenu_wedding.vue?vue&type=script&lang=js"
export * from "./Leftmenu_wedding.vue?vue&type=script&lang=js"
import style0 from "./Leftmenu_wedding.vue?vue&type=style&index=0&id=12418283&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12418283",
  null
  
)

export default component.exports